// extracted by mini-css-extract-plugin
export default {"h90":"Teammates_h90__de+66","container":"Teammates_container__mX-o6","loader":"Teammates_loader__-muCj","title":"Teammates_title__LZsNI"};